module.exports = __webpack_public_path__ + "img/number-leaf.841022bc.svg";